module.exports = __webpack_public_path__ + "img/excoino_logo.f2bb6ee8.svg";